export type ChatSelectionContext = {
  from: number;
  to: number;
  text: string;
};

export type OpenChatOptions = {
  selection?: ChatSelectionContext | null;
};

export function readChatSelectionFromEditor(
  getTextBetween: (from: number, to: number) => string,
  from: number,
  to: number,
): ChatSelectionContext | null {
  if (from === to) {
    return null;
  }

  const text = getTextBetween(from, to);
  if (!text.trim()) {
    return null;
  }

  return { from, to, text };
}
